export default __webpack_public_path__ + "static/media/Agradut.fa68a1ae.jpg";